const CACHE_EMPTY_VALUE = "__EMPTY__"

const getBase64FromPayload = (payload) => {
  if (!payload) return null
  if (typeof payload === "string") return payload

  if (Array.isArray(payload)) {
    for (const item of payload) {
      const nested = getBase64FromPayload(item)
      if (nested) return nested
    }
    return null
  }

  if (typeof payload !== "object") return null

  const candidateKeys = ["base64", "imageBase64", "data", "content", "value", "file"]
  for (const key of candidateKeys) {
    if (typeof payload[key] === "string" && payload[key].trim()) {
      return payload[key]
    }
  }

  for (const value of Object.values(payload)) {
    const nested = getBase64FromPayload(value)
    if (nested) return nested
  }

  return null
}

const toImageDataUrl = (payload) => {
  const rawValue = getBase64FromPayload(payload)
  if (!rawValue) return null

  const trimmed = rawValue.trim()
  if (trimmed.startsWith("data:image/")) {
    return trimmed
  }

  const normalized = trimmed.replace(/\s/g, "")
  const mimeType = normalized.startsWith("/9j/")
    ? "image/jpeg"
    : normalized.startsWith("R0lGOD")
      ? "image/gif"
      : normalized.startsWith("PHN2Zy")
        ? "image/svg+xml"
        : "image/png"

  return `data:${mimeType};base64,${normalized}`
}

const getCachedImage = ({ key, tsKey, ttlMs }) => {
  const rawTs = localStorage.getItem(tsKey)
  const cachedValue = localStorage.getItem(key)
  const ts = Number(rawTs || 0)
  const isFresh = Date.now() - ts < ttlMs

  if (!isFresh || cachedValue === null) {
    return undefined
  }

  if (cachedValue === CACHE_EMPTY_VALUE) {
    return null
  }

  return cachedValue
}

const setCachedImage = ({ key, tsKey, value }) => {
  localStorage.setItem(tsKey, String(Date.now()))
  localStorage.setItem(key, value || CACHE_EMPTY_VALUE)
}

const invalidateAllImageCaches = () => {
  localStorage.removeItem("app.brandLogo.dataUrl")
  localStorage.removeItem("app.brandLogo.ts")
  localStorage.removeItem("app.backgroundImage.dataUrl")
  localStorage.removeItem("app.backgroundImage.ts")
  localStorage.removeItem("app.footerLogo.dataUrl")
  localStorage.removeItem("app.footerLogo.ts")
}

export { toImageDataUrl, getCachedImage, setCachedImage, invalidateAllImageCaches }
